function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#C4C4C4",
  d: "M0 0h24v24H0z"
});

var _ref2 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#ship-ok_svg__a)",
  stroke: "#4D4D4D"
}, /*#__PURE__*/React.createElement("path", {
  d: "M21 13.5V5a2 2 0 00-2-2H5a2 2 0 00-2 2v14a2 2 0 002 2h8.5",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("rect", {
  x: 10,
  y: 3,
  width: 4,
  height: 4,
  rx: 1,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.5 22a5.5 5.5 0 100-11 5.5 5.5 0 000 11z",
  strokeWidth: 2,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.95 15.121l-2.828 2.829L14 15.828",
  strokeWidth: 1.5,
  strokeLinecap: "round"
}));

function SvgShipOk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "ship-ok_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _ref), _ref2);
}

export default __webpack_public_path__ + "/img/ship-ok.svg";
export { SvgShipOk as ReactComponent };